<template>
  <a href="#" @click.prevent="openAllChannels()" class="c-menu__meta-button [ c-button c-button--secondary c-button--large ]">
    <SvgIcon icon="listen" class="c-menu__meta-icon" /> Kies kanaal</a>
</template>

<script>
import { openPlayer } from '../../mixins/radioPlayer';

export default {
  name: 'ChannelButton',
  mixins: [openPlayer],
}
</script>
